import React from "react";
import ErrorBoundary from '../components/Salvavidas'
import Container from "react-bootstrap/Container"
import Login2 from '../views/Login2'
import Home_ordenes_principal from '../views/Home_ordenes_principal'
import firebaseApp from "../firebase/credenciales";
import { getAuth, onAuthStateChanged, sendPasswordResetEmail } from "firebase/auth";
const auth = getAuth(firebaseApp);



function CRUD_ordenes_principal(){

    

    const [usuario, setUsuario] = React.useState(null);

  onAuthStateChanged(auth, (usuarioFirebase) => {
    if (usuarioFirebase) {
      setUsuario(usuarioFirebase);
    } else {
      setUsuario(null);
    }
  });
    return(
   <ErrorBoundary>
    <Container fluid>
      {usuario ? <Home_ordenes_principal usuario={usuario}></Home_ordenes_principal>: <Login2 />}
    </Container>
    </ErrorBoundary>   
    );
}




export default CRUD_ordenes_principal;